import { Box, Button, IconButton } from '@mui/material';
import { Fragment, ReactNode, useState } from 'react';

import DrawerCloseIcon from 'app/components/Icons/DrawerCloseIcon';
import YeloLogo from 'app/components/Icons/YeloLogo';
import { MenuData } from 'app/constants/types';
import useHeader from 'app/widgets/header/model/useHeader';

import DrawerCustom from 'app/components/DrawerCustom';
import BurgerMenuIcon from 'app/components/Icons/BurgerMenuIcon';
import LanguageSwitcher from 'app/components/LanguageSwitcher';
import NavlinkWithTranslation from 'app/components/NavlinkWithTranslation';

import NotificationLayer from 'app/components/Notifications/Notification';
import {
  burgerButton,
  drawerCloseButton,
  drawerContainer,
  drawerHeader,
  header,
  infoSide,
  logo,
  logoSide,
} from './Header.sx';
import HeaderProfile, { HeaderUser } from './HeaderProfile';

interface Props {
  children: (func: () => void) => ReactNode;
  sign: string;
  title: string;
  mailbox: number;
  user?: HeaderUser;
  menu?: MenuData[];
  isDisabled?: boolean;
}

const Header = (props: Props) => {
  const [openBurger, setOpenBurger] = useState(false);

  const { mediumScreen, handleUserProfile } = useHeader();

  return (
    <Box sx={header}>
      <Box sx={logoSide}>
        {mediumScreen && (
          <Button
            sx={burgerButton}
            size={'medium'}
            variant={'outlined'}
            onClick={() => setOpenBurger(true)}
          >
            <BurgerMenuIcon />
          </Button>
        )}

        {props.isDisabled ? (
          <YeloLogo sx={logo} />
        ) : (
          <NavlinkWithTranslation to={`home-page`}>
            <YeloLogo sx={logo} />
          </NavlinkWithTranslation>
        )}
      </Box>

      <Box sx={infoSide}>
        {!props.isDisabled && (
          <Fragment>
            <LanguageSwitcher homePage={true} compact={mediumScreen} />
            <NotificationLayer isDisabled={props.isDisabled} />
            <HeaderProfile user={props.user} sign={props.sign} onClick={handleUserProfile} />
          </Fragment>
        )}
      </Box>

      {mediumScreen && (
        <DrawerCustom menu={props.menu} setOpen={setOpenBurger} open={openBurger} hide={true}>
          <Box sx={drawerContainer}>
            <Box sx={drawerHeader}>
              <YeloLogo sx={logo} />
              <IconButton sx={drawerCloseButton} disableRipple onClick={() => setOpenBurger(false)}>
                <DrawerCloseIcon />
              </IconButton>
            </Box>
            {props.children(setOpenBurger as () => void)}
          </Box>
        </DrawerCustom>
      )}
    </Box>
  );
};

export default Header;
